
import { useQueryClient } from "@tanstack/react-query";
import { useAction } from "convex/react";
import { api } from "../../api";
import { toConvexId } from "@/types/convex";

export const useDeleteNetworkRule = () => {
  const queryClient = useQueryClient();
  const deleteRule = useAction(api.rules.delete.rule);

  return {
    mutateAsync: async (ruleId: string) => {
      console.log('Deleting network rule:', ruleId);
      
      const result = await deleteRule({ 
        id: toConvexId.rule(ruleId)
      });

      console.log('Network rule deleted successfully:', result);
      
      // Invalidate queries after successful deletion
      queryClient.invalidateQueries({ queryKey: ['network-rules'] });
      
      return result;
    },
    isPending: false // Convex mutations handle their own loading state
  };
};
